module.exports = __webpack_public_path__ + "static/media/billing.368fa2ce.svg";